<template>
    <div>
        <h3>Export Survey Results</h3>
        <form class="large-form">
            <div class="form-line">
                <div class="form-field" id="form-field-button-action">
                    <label for="form-input-button-action">Export Format</label>
                    <WSSelect v-model="format" :options="[
                        {value: 'csv', text: 'CSV Responses Table'},
                        {value: 'pdf', text: 'PDF Aggregate Results'},
                    ]" />
                </div>
            </div>
            <div class="form-line">
                <div class="form-field" id="form-field-button-action">
                    <label for="form-input-button-action">Included Questions</label>
                    <WSSelect v-model="included" :options="[
                        {value: 'all', text: 'All Questions'},
                        ... format === 'pdf' ? [{value: 'aggregable', text: 'Aggregable Questions Only'}] : [],
                        ... selectedQuestions.length ? [{value: 'selected', text: 'Selected (Visible) Questions Only'}] : [],
                        //{value: 'pick', text: 'Specific Questions'},
                    ]" />
                </div>
            </div>
            <!--
            <div v-if="included === 'pick'" class="form-line">
                <div class="form-field" id="form-field-button-action">
                    <label for="form-input-button-action">Select Questions</label>
                    <select id="form-input-button-action" v-model="includedQuestions" multiple>
                        <option v-for="question in questions" :key="question.id" :value="question.id">{{
                                question.name ?? question.page_name
                            }}
                        </option>
                    </select>
                </div>
            </div>-->
            
            <div class="form-field form-field-checkbox" id="form-field-display-title"
                v-if="Object.keys(selectedFilters).length > 1"
                style="margin-top: 5px; text-align: left;">
                <input id="form-input-display-title" type="checkbox" style="margin-right: 10px;" v-model="applyFilters">
                <label for="form-input-display-title" class="checkbox-label">Apply Active Filters</label>
            </div>
        </form>
        <div class="form-actions">
            <div type="button" class="ws-button ws-button-secondary" @click="onCancel">Cancel</div>
            <div type="submit" class="ws-button ws-button-main" @click="onExport">Export Results</div>
        </div>
    </div>
</template>

<script>
import FileSaver from 'file-saver';
import { api } from "@/utils/client";
import WSSelect from "@/components/elements/WSSelect.vue";

export default {
    name: 'ExportForm',
    components: {WSSelect},
    props: {
        selectedQuestions: {
            type: Array,
            default: () => []
        },
        selectedFilters: {
            type: Object,
            default() {
                return {};
            }
        },
    },
    data() {
        return {
            format: 'csv',
            included: 'all',
            applyFilters: false,
            includedQuestions: [],
        }
    },
    computed: {
        questions() {
            return this.$store.getters[`surveyQuestions/orderedList`];
        }
    },
    created() {
        this.$store.dispatch('surveyQuestions/getBySurvey', {})
    },
    methods: {
        onCancel() {
            this.$emit('cancel')
        },
        onExport() {
            if (this.format === 'csv') {
                this.exportToCsv();
            }
            this.$emit('cancel')
        },
        async exportToCsv() {
            const params = {};
            if (this.included === 'pick') {
                params.questions = this.includedQuestions;
            }
            if (this.included === 'selected') {
                params.questions = this.selectedQuestions;
            }
            if (this.included === 'selected') {
                params.filters = this.selectedFilters;
            }

            const {data} = await api.post(`${this.$store.state.teamId}/surveys/${this.$store.state.surveys.selected}/responses/export`, {params})
            const headers = Object.keys(data[0]);
            const content = data.reduce((rows, row) => [...rows, headers.map(key => row[key])], [headers]).join("\n")
            const blob = new Blob([content], {type: 'text/csv;charset=utf-8,'})
            FileSaver.saveAs(blob, 'survey-export.csv');
        },
    }
}
</script>
